<template>
    <d-container fluid class="main-content-container px-4 pb-4">
        <d-row no-gutters class="page-header py-4">
            <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
                <h3 class="page-title">Page Report</h3>
            </d-col>
        </d-row>

        <template>
            <d-card v-if="isLoading" class="d-flex flex-column align-items-center p-4">
                <h5 class="mb-4">
                    Loading report...
                </h5>
                <div
                    class="spinner-border text-primary"
                    role="status"
                >
                    <span class="sr-only">
                        Loading...
                    </span>
                </div>
            </d-card>
            <template v-else>
                <d-alert
                    v-if="report.length === 0"
                    theme="warning"
                    show
                >
                    No records found. Please try to set different filters.
                </d-alert>
                <template v-else>
                    <d-col
                        sm="12"
                        xs="12"
                        class="d-flex justify-content-center justify-content-md-end"
                    >
                        <b-dropdown
                            right
                            variant="secondary"
                            class="mb-2"
                            text="Export"
                        >
                            <b-dropdown-item :href="exportTo('csv')">CSV</b-dropdown-item>
                            <b-dropdown-item :href="exportTo('xlsx')">XLSX</b-dropdown-item>
                        </b-dropdown>
                    </d-col>

                    <d-card>
                        <b-table
                            responsive
                            striped
                            hover
                            :items="report"
                        />
                    </d-card>
                </template>
            </template>
        </template>
    </d-container>
</template>

<script>
    import notification from '@/mixins/notification'
    import loader from '@/mixins/loader'
    import { AnalysisService, AuthService } from '@/main'

    export default {
        mixins: [notification, loader],

        data() {
            return {
                isLoading: true,
                report: [],

                restUrl: process.env.VUE_APP_REST_API,
                token: AuthService.getToken()
            }
        },

        methods: {
            async getReport() {
                this.isLoading = true

                try {
                    this.report = await AnalysisService.getPageReport(this.$route.params.id)
                    this.isLoading = false
                } catch(e) {
                    this.showNotification('warn', 'Oops! we have a problem', 'Something went wrong!')
                    console.error(e)
                }
            },

            exportTo(format) {
                return `${this.restUrl}reports/page/${this.$route.params.id}/export/${format}?token=${this.token}`
            },
        },

        mounted() {
            this.getReport()
        },
    }
</script>
